"use strict";

// Shared by hard asset types with no extra inventory fields shown on the Condition tab.
const NoInventoryData = function () {
  var getProps = function () {
    return {};
  };

  return {
    getProps,
  };
};

module.exports = NoInventoryData();
